module.exports = __webpack_public_path__ + "img/support.89c6af17.png";